import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../types/store'
import {
    alertErrorMessage,
    throwSuccessMessage,
} from '../../../../utils/Errors'
import { fetchProductsGroups } from './fetchProductsGroups'
import { getUrlWithVersion } from '../../../../api/api'

export const deleteProductsGroup = createAsyncThunk<
    void,
    { groupId: string; cb?: Function },
    ThunkConfig<string>
>('productsSlice/deleteProductsGroup', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { groupId, cb } = args

    try {
        await api.delete(getUrlWithVersion(`/groups/${groupId}`))
        dispatch(fetchProductsGroups())
        throwSuccessMessage(`Success!`)
        if (cb && typeof cb === 'function') dispatch(cb())
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to delete the group')
    }
})
